module.exports = __webpack_public_path__ + "media/images/like-4aa687bb5259ae64f6f78e4fee807638.svg";